import { Property } from "./property.model";

export class ProductItem {
  productId: number = 0;
  productItemId: number = 0;
  itemPrice: number = 0;
  listOfProperties: Property [] = [];
  imageURL: string = '';
  productTitleFr: string = '';
  productTitleEn: string = '';
  customerProductNumber:string = '';
  productItemNumber:string = '';
  
  constructor() { }
}
